import React, { useEffect, useState } from "react";
import axios from "axios";
import { getDocs } from "../../api/aprvDoc";

function WelcomeCard({ currentUser }) {
  const [waitCount, setWaitCount] = useState(0);
  const [mailCount, setMailCount] = useState(0);

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (!token) return;
    getDocs(1, 1, '', 'wait', token)
      .then(({ total }) => setWaitCount(total ?? 0))
      .catch(() => {});
    axios.get('/api/mail/list/count', { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => { if (data.success) setMailCount(data.total ?? 0); })
      .catch(() => {});
  }, []);

  return (
    <div className="card mb-2 overflow-hidden" style={{ minHeight: "300px" }}>
      <div className="bg-primary bg-soft">
        <div className="row">
          <div className="col-7">
            <div className="text-primary p-3">
              <h5 className="text-primary">Welcome Back!</h5>
              <p></p>
            </div>
          </div>
          <div className="col-5 align-self-end">
            <img
              src="/images/profile-img.png"
              alt="프로필 이미지"
              className="img-fluid"
            />
          </div>
        </div>
      </div>
      <div className="card-body pt-0">
        <div className="row">
          {/* Profile Section */}
          <div className="col-sm-4">
            <div className="avatar-md profile-user-wid mb-4">
              <img
                id="profile-MyPhoto"
                src={
                  currentUser && currentUser.photo_path && currentUser.photo_path.trim() !== ""
                    ? `${currentUser.photo_path}?${new Date().getTime()}`  
                    : "/images/img_org_noimage.png"   
                }
                className="img-thumbnail rounded-circle"
                style={{ width: "72px", height: "72px", marginTop: "-30px" }}
                alt="프로필"
              />
            </div>
            <h5 className="font-size-15 text-truncate" id="profile-MyName">
              {currentUser ? `${currentUser.name} / ${currentUser.position}` : "My Name"}
            </h5>
            <p className="text-muted mb-0 text-truncate" id="profile-MyDept">
              {currentUser ? currentUser.dept_name : "My Department"}
            </p>
          </div>

          {/* Stats Section */}
          <div className="col-sm-8">
            <div className="pt-4">
              <div className="row">
                <div className="col-4">
                  <p className="text-muted mb-1">메일</p>
                  <h5 className="font-size-15">{mailCount}</h5>
                </div>
                <div className="col-4">
                  <p className="text-muted mb-1">결재문서</p>
                  <h5 className="font-size-15">{waitCount}</h5>
                </div>
                <div className="col-4">
                  <p className="text-muted mb-0">잔여휴가</p>
                  <h5 className="font-size-15">3</h5>
                </div>
              </div>
              <div className="mt-4">
                <a 
                  href={currentUser ? `/users/${currentUser.id}` : "/profie"}
                  className="btn btn-primary waves-effect waves-light btn-sm"
                >
                  View Profile <i className="mdi mdi-arrow-right ms-1"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WelcomeCard;